import { type FpB2bProductCatalogDTO } from '@cart-services/types'
import { isNewProduct } from '../../utils/new-product-filter'
import { PRODUCT_CARD_BADGE, type ProductCardEntry } from '../types/product-card-entry'
import { buildVariationEntry } from './build-product-card-entry'

/**
 * 取得品牌的新品 product cards。
 *
 * 把母商品攤平：每個符合「新品」條件的 variation 各自成為一張卡，
 * 加購對話框只顯示該 variation。catalog 未就緒時回傳空陣列。
 */
export const getNewArrivalProductCards = (productCatalogDto: FpB2bProductCatalogDTO | undefined): ProductCardEntry[] => {
  if (!productCatalogDto) return []
  return productCatalogDto.products
    .flatMap(category => category.all_product)
    .flatMap(product =>
      product.variations
        .filter(variation => isNewProduct(variation.product_create_time))
        .map(variation => buildVariationEntry({
          product,
          variation,
          badge: PRODUCT_CARD_BADGE.NEW,
        })),
    )
}
